<template>
    <div class="as-incident-list__event as-d-flex as-align-items-center">
        <div class="as-incident-list__event-time as-d-flex as-align-items-center">
        <div>{{ goal.time }}'</div>
        </div>
        <div :class="`as-incident-list__event-detail as-d-flex as-flex-1 as-incident-list__event--${modeTeam}`">
        <div class="as-incident-list__event-score as-d-flex as-flex-1">
            <button>
            <span class="as-score-home">{{ goal.point?.home }}</span>
            -
            <span class="as-score-away">{{ goal.point?.away }}</span>
            </button>
        </div>
        <div class="as-incident-list__event-icon as-d-flex justify-content-center as-align-items-center">
            <div class="as-icon">
                <IBall/>
            </div>
        </div>
        <div class="as-incident-list__player as-d-flex as-flex-1">
            <PlayerItem
              :name="goal?.player?.full_name ?? goal?.player?.first_name"
              :img="getImgUrlBySport('player', goal?.player ? goal.player?.id.toString() : 'default')"
            />
        </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import IBall from '~src/components/icons/incident/IBall.vue';
    import PlayerItem from '~src/components/foot_stats/final_score/PlayerItem.vue';
    import type { IGoalDetails } from '~src/interfaces/footystats';

    interface Props{
        modeTeam?: string,
        goal: IGoalDetails
    }
    withDefaults(defineProps<Props>(), {
        modeTeam: 'home'
    })

</script>

<script lang="ts">
export default {};
</script>
